import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { BehaviorSubject } from 'rxjs';
import { TextFilter, RangeDateFilterStore, EventAthleteResultsCombo, DateFilterStore, YesNotCombo } from '../../../common-page-components/stores/filters-store/filters-store';
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
export class ResultsAthleteFiltersService extends FiltersAbstractService {
    constructor(common_service) {
        super();
        this.common_service = common_service;
        /**
         * Categories combo.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.categoriesCombo = this.common_service.athleteCategoriesCombo;
        /**
         * Text filter.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.textFilter = new TextFilter('results-text-filter');
        /**
         * Range date combo.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.rangeDate = new RangeDateFilterStore("range_date", new DateFilterStore("from", "From", undefined, undefined, new BehaviorSubject({ value: undefined })), new DateFilterStore("to", "To", undefined, undefined, new BehaviorSubject({ value: new Date() })));
        /**
         * Event type combo.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.eventTypeCombo = new EventAthleteResultsCombo('Event:', 'event-results-combo');
        /**
         * Podiums combo.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.podiumsCombo = new YesNotCombo('Podiums only:', 'podiums-combo', { Name: "No", Value: false });
    }
    /**
     *
     * @inheritdoc
     * @memberof ResultsAthleteFiltersService
     */
    generateDefaultValues() {
    }
    /**
     *
     * @inheritdoc
     * @memberof ResultsAthleteFiltersService
     */
    getDataStreamWithFilters() {
        return;
    }
}
ResultsAthleteFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResultsAthleteFiltersService_Factory() { return new ResultsAthleteFiltersService(i0.ɵɵinject(i1.FiltersAthleteGeneralService)); }, token: ResultsAthleteFiltersService, providedIn: "root" });
